import type { Routes } from '@angular/router';
import { createMetaResolverWithDealer, defaultTitleResolver, PageContentType } from '@hyundai/ng-common-lib';
import { LegalNoticesPageComponent } from './legal-notices-page.component';

export default [
    {
        path: '',
        component: LegalNoticesPageComponent,
        title: defaultTitleResolver('Rechtliche Hinweise'),
        resolve: {
            meta: createMetaResolverWithDealer((dealer) => {
                return {
                    description: `Hier finden Sie die rechtlichen Hinweise von ${dealer.name} in ${dealer.city}.`,
                };
            }),
        },
        data: {
            contentType: PageContentType.LEGAL,
        },
    },
] satisfies Routes;
